import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css"; //for navbar underline
import logo from "../static/homepage/logo_h.png";
import { email, navLinks } from "../static/constants";

const Navbar = () => {
  const [isOpen, setisOpen] = useState(false);

  return (
    <div className="w-full fixed z-50 antialiased font-rubik backdrop-blur-sm bg-transparent border-white transition-colors duration-300">
      <div className="w-full flex flex-col px-4 md:hidden">
        <div className="w-full flex justify-between items-center z-50">
          <Link to="/">
            <img
              src={logo} // Route of the image file
              height={120} // Desired size with correct aspect ratio
              width={120} // Desired size with correct aspect ratio
              alt="s4ds Logo"
              onClick={() => {
                setisOpen(false);
              }}
            />
          </Link>
          <button
            className="pointer-events-auto text-white opacity-100 w-10 h-10 relative focus:outline-none"
            onClick={() => {
              setisOpen(!isOpen);
            }}>
            <div className="block w-10 absolute left-1/2 top-1/2   transform  -translate-x-1/2 -translate-y-1/2 ">
              <span
                className={`block rounded-full absolute h-0.5 w-9 bg-current transform transition duration-700 ease-in-out ${
                  isOpen ? "-rotate-45" : "-translate-y-2.5"
                }`}></span>
              <span
                className={`block rounded-full absolute  h-0.5 w-9 bg-current   transform transition duration-700 ease-in-out ${
                  isOpen ? "translate-x-10 opacity-0" : ""
                }`}></span>
              <span
                className={`block rounded-full absolute  h-0.5 w-9 bg-current transform  transition duration-700 ease-in-out ${
                  isOpen ? "rotate-45" : "translate-y-2.5"
                }`}></span>
            </div>
          </button>
        </div>
        <div
          className={`w-full h-screen transition-all duration-1000 ${
            !isOpen && "-translate-y-full"
          } top-0 left-0 bg-black z-40 absolute flex flex-col items-center justify-center gap-10`}>
          {navLinks.map(({ link, name }, index) => {
            return (
              <Link
                to={link}
                kye={index}
                onClick={() => {
                  setisOpen(false);
                }}>
                <div className="pointer btn flex items-center justify-start px-5 py-2 bg-gradient-to-r  from-blue-400 via-indigo-600 to-pink-400  rounded-full text-xl font-bold leading-normal text-white font-quicksand">
                  {name}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
      <nav className="w-full hidden md:flex container mx-auto">
        <div className="flex space-x-2 items-center justify-between px-4 lg:px-20 w-full">
          <div className="w-full">
            <Link to="/">
              <img
                src={logo} // Route of the image file
                height={160} // Desired size with correct aspect ratio
                width={160} // Desired size with correct aspect ratio
                alt="Your Name"
              />
            </Link>
          </div>
          <div className="flex space-x-8 items-start justify-center w-full">
            {navLinks.map(({ link, name }, index) => {
              return (
                <Link
                  to={link}
                  key={index}
                  className={`nav-link text-xl font-semibold leading-normal tracking-widest text-gray-300 font-quicksand ${
                    name === "Xtract 5.0" ? "xtract-title font-bold" : ""
                  }`}>
                  {name}
                </Link>
              );
            })}
          </div>

          <div className="w-full flex justify-end">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                "https://docs.google.com/document/d/1BA4kyww5gYWBKA-UaOSGXi3ROmiwsUYS3qrDsbAzzj8"
              }>
              <div className="pointer btn flex items-center justify-start px-5 py-2 bg-gradient-to-r  from-blue-400 via-indigo-600 to-pink-400  rounded-full text-base font-bold leading-normal text-white">
              <a href={`mailto:${email}`}>
                Contact Us
              </a>
              </div>
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
